import { getConfig } from "./config";
import { IMaintenanceFields } from "types";

const DEFAULT_VALUES = {
  allowedUsers: [] as string[],
  games: {
    BTY: {
      enabled: false,
      announcementEnabled: false,
      maintenanceAnnouncement: "",
      maintenanceMessage: "",
    },
  },
};

export const getMaintenanceFlagEntry = async (): Promise<IMaintenanceFields> => {
  try {
    const jsonPath = getConfig('REACT_APP_MAINTENANCE_FLAGS_JSON_PATH') || '';
    const response = await fetch(jsonPath, {
      headers: {
        "Content-Type": "application/json",
      },
      cache: "no-cache",
    });

    if (response.ok) {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error("Error fetching flags:", error);
  }
  return Promise.resolve(DEFAULT_VALUES);
};